module.exports = __webpack_public_path__ + "img/login.c10b86d4.png";